import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import GlobalMarkupOptions from '@nerdwallet/coin/GlobalMarkupOptions';
import { Title } from '@nerdwallet/currency';

import { getJobRelativePath } from '~/client/lib/department-utils';
import CompanyJob from './company-job/company-job';
import CompanyApplyJob from './company-apply-job/company-apply-job';
import styles from './job-page.module.less';

const JobPage = ({ job }) => {
  const greenhouseRef = React.useRef(null);

  return (
    <div ref={greenhouseRef} className={styles.grnhseAppCont}>
      <GlobalMarkupOptions>
        {{
          theme: 'company',
          ogTags: {
            url: getJobRelativePath(job),
            title: job.title,
          },
        }}
      </GlobalMarkupOptions>
      <CompanyJob job={job} />
      <div id="applyJob">
        <Title size="small" className={styles.jobTitle} component="h2">
          Apply for this role
        </Title>
        <CompanyApplyJob id={job.id} />
      </div>
    </div>
  );
};

JobPage.displayName = 'Job Page';

JobPage.propTypes = {
  job: PropTypes.shape({
    id: PropTypes.string,
    content: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

export default withRouter(JobPage);
